import Chart from 'react-apexcharts';
import type { Props as ChartProps } from 'react-apexcharts';
import { useColorModeValue } from '@chakra-ui/react';

interface LineChartProps {
  chartData: ChartProps['series'];
  chartOptions?: ApexCharts.ApexOptions;
}

export default function LineChart({ chartData, chartOptions }: LineChartProps) {
  const textColor = useColorModeValue('#1B2559', '#FFFFFF');
  const gridColor = useColorModeValue('#E0E5F2', '#2D3748');

  const defaultOptions: ApexCharts.ApexOptions = {
    chart: {
      toolbar: { show: false },
      dropShadow: {
        enabled: true,
        top: 13,
        left: 0,
        blur: 10,
        opacity: 0.1,
        color: '#6200ea',
      },
    },
    colors: ['#6200ea', '#39B8FF'],
    markers: {
      size: 0,
      colors: 'white',
      strokeColors: '#6200ea',
      strokeWidth: 3,
      strokeOpacity: 0.9,
      fillOpacity: 1,
      hover: { size: 5 },
    },
    tooltip: { theme: 'dark' },
    dataLabels: { enabled: false },
    stroke: { curve: 'smooth' },
    xaxis: {
      labels: { style: { colors: textColor, fontSize: '12px', fontWeight: '500' } },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: { style: { colors: textColor, fontSize: '12px', fontWeight: '500' } },
    },
    legend: { show: false },
    grid: {
      show: true,
      borderColor: gridColor,
      strokeDashArray: 5,
      yaxis: { lines: { show: true } },
      xaxis: { lines: { show: false } },
    },
  };

  const mergedOptions = { ...defaultOptions, ...chartOptions };

  return (
    <Chart
      options={mergedOptions}
      series={chartData}
      type="line"
      width="100%"
      height="100%"
    />
  );
}
